export default "__VITE_ASSET__KvQ9mrvf__"